<template>
  <div class="title" :class="'title' + type">
    <img class="logo" :src="$env.imgUrl + 'logo.png'" alt="">
    <div class="text">
      <div class="cn">{{ cn }}</div>
      <div class="en">{{ en }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    cn: {
      type: String
    },
    en: {
      type: String
    },
    type: {
      type: String
    }
  },
  data () {
    return {
    }
  },
  methods: {
    //
  }
}
</script>
<style lang="less" scoped>
.title{
  display: flex;
  align-items: center;
  .logo{
    width: 60px;
    height: 60px;
    margin-right: 14px;
  }
  .cn{
    font-family: systh;
    font-size: 30px;
    line-height: 34px;
  }
  .en{
    font-family: systh;
    font-size: 14px;
  }
}
.title1{
  color: #C9273A;
}
.title2{
  color: #fff;
}
</style>
